module.exports = __webpack_public_path__ + "media/images/fmdd_loading1-b51bf5c31243cf00dd13260894f45643.png";